import './layout.scss';

import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { ROUTES } from '@/shared/constants';
import { useTranslationsLoader } from '@/shared/hooks/useTranslationsLoader';
import { MainSpinner } from '@/shared/ui';
import ErrorTemplate from '@/shared/widgets/errors/error-template';
import { setAuthModalOpen } from '@/store/auth.slice';
import { useAppDispatch, useAppSelector } from '@/store/store';

import { AuthModal } from './entities';
import { useAuthInit } from './hooks/useAuthInit';
import { useDealerGroupInit } from './hooks/useDealerGroupInit';
import { useProductTypeInit } from './hooks/useProductTypeInit';
import Header from './widgets/header';

const Layout: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { isAuthModalOpen } = useAppSelector((state) => state.auth);

  useTranslationsLoader();
  useAuthInit();
  useDealerGroupInit();
  useProductTypeInit();

  const handleCloseAuthModal = () => {
    dispatch(setAuthModalOpen(false));
  };

  return (
    <div className="layout">
      <Header />
      <main className="layout__main">
        <ErrorBoundary
          onError={console.error}
          fallback={
            <div className="layout__error">
              <ErrorTemplate
                type="oops"
                redirect={{
                  text: t('go_to_create_application'),
                  href: ROUTES.create
                }}
              />
            </div>
          }
        >
          <Suspense fallback={<MainSpinner fullScreen={true} />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </main>

      <AuthModal open={isAuthModalOpen} onClose={handleCloseAuthModal} />
    </div>
  );
};

export default Layout;
